var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMarkerCharge3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 66,
    height: 66,
    viewBox: "0 0 66 66",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.9999 0.660156C19.5887 0.660156 8.71851 11.5172 8.71851 24.9152C8.71851 38.3066 32.9999 65.3401 32.9999 65.3401C32.9999 65.3401 57.2813 38.3066 57.2813 24.9152C57.2813 11.5172 46.4111 0.660156 32.9999 0.660156ZM32.9999 41.0852C24.0635 41.0852 16.8101 33.845 16.8101 24.9152C16.8101 15.9854 24.0569 8.74516 32.9999 8.74516C41.9429 8.74516 49.1897 15.9854 49.1897 24.9152C49.1897 33.845 41.9429 41.0852 32.9999 41.0852Z",
    fill: "#6ABF62"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarkerCharge3);
export default __webpack_public_path__ + "static/media/marker-charge3.a393f581209a50f8d00e6824026cfac5.svg";
export { ForwardRef as ReactComponent };